import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FaQuestionCircle } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';


const QuestionaireModal = ({ data, modalOpen, setModalOpen }) => {
//   const [modalOpen, setModalOpen] = useState(false);

  const toggle = () => setModalOpen(!modalOpen);

  return (
    <div className='text-center mt-5'>
      <Modal isOpen={modalOpen} toggle={toggle} centered size='lg'>
        <ModalHeader toggle={toggle}>
                  <div className='d-flex justify-content-between align-items-center w-100'>
                      
            <p className='fw-bold text-secondary' >
              {/* <FaQuestionCircle className='me-2' /> */}
              Questionnaire
            </p>
            {/* <Button close className='btn-close' onClick={toggle}>
              <MdClose size={20} />
            </Button> */}
          </div>
        </ModalHeader>

        <ModalBody className='bg-light'>
          {data.length>0 ? data.map((item, index) => (
            <div key={item.id} className='mb-4 p-3 bg-white shadow rounded'>
              <h5 className='text-dark'>
                Q{index + 1}: {item.question}
              </h5>
              <p className='ms-3 text-secondary mb-0'>
                <strong>Ans:</strong> {item.answer}
              </p>
            </div>
          )): 'No Questions Found'}
        </ModalBody>

        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default QuestionaireModal;
